import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=e5766908&"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports